/**
 * Reminders module (owner WP3-REMIND; BUILD-PLAN M12). One engine for every
 * automated patient message: the appointment reminder sequence, the
 * Unconfirmed worklist, the message log with reasons, and job health.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'reminders',
    title: 'Reminders',
    version: '0.1.0',
    owner: 'WP3-REMIND',
    entitlementKey: null,
    permissions: ['comms.view', 'comms.send', 'settings.manage', 'schedule.edit', 'money.view'],
    routes: [
      {
        id: 'reminders',
        path: '/reminders',
        title: 'Reminders',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Reminders',
        group: 'patients',
        routeId: 'reminders',
        icon: 'bell',
        order: 35,
        permission: 'comms.view',
      },
    ],
    commands: [
      {
        id: 'reminders.open',
        title: 'Go to Reminders',
        keywords: ['confirmations', 'reminder sequence', 'unconfirmed', 'texts', 'job health'],
        routeId: 'reminders',
        permission: 'comms.view',
      },
      {
        id: 'reminders.unconfirmed',
        title: 'Work the Unconfirmed list',
        keywords: ['confirm', 'unconfirmed', 'call list', 'left message'],
        routeId: 'reminders',
        permission: 'comms.view',
      },
    ],
    shortcuts: [
      { keys: 'g u', description: 'Go to Reminders (Unconfirmed)', routeId: 'reminders' },
    ],
    sseEntityKeys: ['appointment'],
    phiReadPoints: ['reminders.log', 'reminders.appointment', 'reminders.unconfirmed'],
  }),
  pages: {
    reminders: () => import('./RemindersPage.js'),
  },
});
